export default __webpack_public_path__ + "static/media/picture.98675679.svg";